module.exports = __webpack_public_path__ + "static/media/cicchetti_thumb_even.e449f426.webp";